export function formalizeTranslation(translation: string): string {
  return translation
    .replace(/Leerling/g, 'Student')
    .replace(/leerling/g, 'student')
    .replace(/LEERLING/g, 'STUDENT');
}
